import React from 'react';

const VisibleView = ({ when, children }) => when ? children : null;

export default VisibleView;
